/**
 * 큐레이터 마이페이지 영역 figma 브랜드 블루 (#245eff).
 * dot 뱃지, 쿠폰 hero band 등 강조 색상에 공통 사용.
 */
export const BRAND_BLUE = '#245eff';
export const BRAND_BLUE_BG = 'rgba(36,94,255,0.05)';
export const BRAND_BLUE_BORDER = 'rgba(36,94,255,0.4)';
